<div class="fantasy-container">
  <div class="container d-lg-flex flex-lg-column banner-container">
    <a class="back-btn text-white font-size-14 d-lg-flex d-none flex-row align-items-center fw-bold" [routerLink]="['/games']">
      <span class="material-symbols-outlined"> keyboard_arrow_left </span>{{ 'games.banner.back.title' | translate }}
    </a>
    <img class="banner-img" [src]="'games/pick-a-player-banner.jpg' | contentAssetImage" alt="pick a player banner" />
  </div>

  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="container points-leaderboard-container d-flex flex-row w-100 pt-lg-2">
      <div class="leaderboard-container justify-content-between d-flex flex-row bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> crown </span>
        </div>
        <div class="rank-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.season.rank' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">
            @if (currentUser?.Position) {
              {{ currentUser?.Position }}
            } @else {
              -
            }
          </p>
        </div>
      </div>

      <div class="points-container d-flex flex-row justify-content-between bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> trending_up </span>
        </div>
        <div class="points-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.total.points' | translate }}</p>
          <p class="font-size-24 text-white fw-bold mb-0">
            @if (currentUser?.Points) {
              {{ currentUser?.Points }}
            } @else {
              0
            }
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <fgb-fantasy-nav></fgb-fantasy-nav>
  <router-outlet></router-outlet>
</div>
